import { render } from "./ForgotPass.vue?vue&type=template&id=db0f23e6&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=db0f23e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0f23e6"]])

export default __exports__